<app-return-rate-benchmark-filters
  *ngIf="years"
  [years]="years"
  [collectionStreams]="collectionStreams"
  (search)="searchData($event)"
>
</app-return-rate-benchmark-filters>
<mat-divider></mat-divider>
<div class="chart-container" *ngIf="data">
  <app-return-rate-benchmark-by-year-chart
    [title]="text"
    [subtitle]="subtitle"
    [data]="data"
  ></app-return-rate-benchmark-by-year-chart>
</div>
